export default class API {
  static #baseUrl = "https://api.xn--y9aan1feuo.xn--y9a3aq/api";
  // static #baseUrl = "http://192.168.101.12:8080/api";

  // method POST
  static async post(path, body) {
    const r = await fetch(`${API.#baseUrl}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    try {
      return {
        status: r.status,
        data: await r.json(),
      };
    } catch (error) {
      return {
        status: r.status,
      };
    }
  }

  static async postToken(path, body, token) {
    const r = await fetch(`${API.#baseUrl}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    try {
      return {
        status: r.status,
        data: await r.json(),
      };
    } catch (error) {
      console.log(error);
      return {
        status: r.status,
      };
    }
  }

  // method GET
  static async get(path) {
    const r = await fetch(`${API.#baseUrl}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    try {
      return {
        status: r.status,
        data: await r.json(),
      };
    } catch (error) {
      return {
        status: r.status,
      };
    }
  }

  static async getToken(path, token) {
    const r = await fetch(`${API.#baseUrl}${path}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    try {
      return {
        status: r.status,
        data: await r.json(),
      };
    } catch (error) {
      return {
        status: r.status,
      };
    }
  }

  // method DELETE
  static async deleteToken(path, token) {
    const r = await fetch(`${API.#baseUrl}${path}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    try {
      return {
        status: r.status,
        data: await r.json(),
      };
    } catch (error) {
      return {
        status: r.status,
      };
    }
  }

  // method PUT
  static async putToken(path, body, token) {
    const r = await fetch(`${API.#baseUrl}${path}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    try {
      return {
        status: r.status,
        data: await r.json(),
      };
    } catch (error) {
      return {
        status: r.status,
      };
    }
  }
}
